import { Address } from 'viem';
import { useChainId } from 'wagmi';
import { getChainId } from '../libs/web3-modal';
const useTestnet = process.env.REACT_APP_TESTNET === 'true';

const TESTNET_MAP_VAULT_ADDRESS = useTestnet
  ? {
      [getChainId('ethereum-testnet')]: process.env.REACT_APP_ETHEREUM_VAULT_CONTRACT_ADDRESS,
    }
  : {};

const MAP_VAULT_ADDRESS = {
  [getChainId('bitLayer')]: process.env.REACT_APP_BITLAYER_VAULT_CONTRACT_ADDRESS,
  [getChainId('ethereum')]: process.env.REACT_APP_ETHEREUM_VAULT_CONTRACT_ADDRESS,
  [getChainId('nibiru')]: process.env.REACT_APP_NIBIRU_VAULT_CONTRACT_ADDRESS,
  [getChainId('arbitrum')]: process.env.REACT_APP_ARB_VAULT_CONTRACT_ADDRESS,
  [getChainId('binance')]: process.env.REACT_APP_BSC_VAULT_CONTRACT_ADDRESS,
  // [chains.sei.id]: process.env.REACT_APP_SEI_VAULT_CONTRACT_ADDRESS,
  [getChainId('avalanche')]: process.env.REACT_APP_AVALANCHE_VAULT_CONTRACT_ADDRESS,
  ...TESTNET_MAP_VAULT_ADDRESS,
} satisfies Record<number, Address>;

export const useVaultAddress = () => {
  let chainId = useChainId();

  const address = MAP_VAULT_ADDRESS[chainId];

  if (!address) {
    // throw new Error(`Unsupported network ${chainId}`);
    return '' as Address;
  }

  return address;
};
